import { call, put, takeLatest } from "redux-saga/effects";
import { schema } from "normalizr";
import { authorizedRequest } from "utils/api";
import _ from "lodash";
import {
  defaultReturn,
  makePayload,
  generateDefaultActions,
  requestSaga
} from "store/utils/helpers";
import {
  ToastError
} from "components/Global/Toasts/Toasty";

export const BANK_SWAP_GET_REQUEST = "BANK_SWAP_GET_REQUEST";
export const BANK_SWAP_GET_FAILURE = "BANK_SWAP_GET_FAILURE";
export const BANK_SWAP_GET_SUCCESS = "BANK_SWAP_GET_SUCCESS";

export const BANK_SWAP_CALCULATE_REQUEST = "BANK_SWAP_CALCULATE_REQUEST";
export const BANK_SWAP_CALCULATE_FAILURE = "BANK_SWAP_CALCULATE_FAILURE";
export const BANK_SWAP_CALCULATE_SUCCESS = "BANK_SWAP_CALCULATE_SUCCESS";

export const RESET_TEST_DATA = "RESET_TEST_DATA";

export const BANK_SWAP_KEY = "bankSwap";
export const BANK_SWAP_ENTITY = new schema.Entity(BANK_SWAP_KEY, {});
export const BANK_SWAP_SCHEMA = [BANK_SWAP_ENTITY];

export const CALCULATE_SWAP_WITH_QUOTE = generateDefaultActions("CALCULATE_SWAP_WITH_QUOTE");
export const calculateSwapWithQuote = payload => makePayload(CALCULATE_SWAP_WITH_QUOTE.value, payload);
function* calculateSwapWithQuoteSaga(payload) {
  const url = "/calc/calculateSwapWithQuote";
  yield requestSaga(CALCULATE_SWAP_WITH_QUOTE, url, "POST", payload);
}

export const CALCULATE_SWAP_WITHOUT_QUOTE = generateDefaultActions("CALCULATE_SWAP_WITHOUT_QUOTE");
export const calculateSwapWithoutQuote = payload => makePayload(CALCULATE_SWAP_WITHOUT_QUOTE.value, payload);
function* calculateSwapWithoutQuoteSaga(payload) {
  const url = "/calc/calculateSwapWithoutQuote";
  yield requestSaga(CALCULATE_SWAP_WITHOUT_QUOTE, url, "POST", payload);
}

const initialState = {
  notional: "",
  start: new Date().toISOString(),
  term: "",
  amortize: true,
  amortTerm: "",
  ioPeriod: "",
  loanSpread: "",
  bankQuote: "",
  swap: {
    netPresentValue: "",
    creditCharge: "",
    swapRevenue: "",
    midRate: "",
    allInRate: "",
    pv01: "",
    mortgagePayment: ""
  }
};

export default function bankSwapReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case BANK_SWAP_GET_SUCCESS:
      return {
        ...state,
        ...payload.payload,
        data: payload.data
      };

    case BANK_SWAP_CALCULATE_SUCCESS:
      return {
        ...state,
        ...payload.payload,
        data: payload.data
      };
    case CALCULATE_SWAP_WITHOUT_QUOTE.success:
      return defaultReturn(state, payload, "swap");
    case CALCULATE_SWAP_WITHOUT_QUOTE.failure:
      ToastError(_.get(payload, "response.data.message", "Something went wrong"));
      break;
    case CALCULATE_SWAP_WITH_QUOTE.failure:
      ToastError(_.get(payload, "response.data.message", "Something went wrong"));
      break;
    case CALCULATE_SWAP_WITH_QUOTE.success:
      return defaultReturn(state, payload, "swap");
    case RESET_TEST_DATA:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
}

// GET BankSwap
export function getBankSwap(payload) {
  return {
    type: BANK_SWAP_GET_REQUEST,
    payload
  };
}
export function getBankSwapSuccess(payload) {
  return {
    type: BANK_SWAP_GET_SUCCESS,
    payload
  };
}
export function getBankSwapFailure(error) {
  return {
    type: BANK_SWAP_GET_FAILURE,
    error
  };
}

// CALCULATE BankSwap
export function calculateBankSwap(payload) {
  return {
    type: BANK_SWAP_CALCULATE_REQUEST,
    payload
  };
}
export function calculateBankSwapSuccess(payload) {
  return {
    type: BANK_SWAP_CALCULATE_SUCCESS,
    payload
  };
}
export function calculateBankSwapFailure(error) {
  return {
    type: BANK_SWAP_CALCULATE_FAILURE,
    error
  };
}

// Saga GET BankSwap
function* getBankSwapSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      `/calculators/bankswap?loanId=${payload.payload}`,
      "GET"
    );
    yield put(getBankSwapSuccess(response));
  } catch (error) {
    yield put(getBankSwapFailure(error));
  }
}

// Saga CALCULATE BankSwap
function* calculateBankSwapSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      "/calculators/bankswap",
      "POST",
      payload
    );
    yield put(calculateBankSwapSuccess(response));
  } catch (error) {
    yield put(calculateBankSwapFailure(error));
  }
}

export function* bankSwapSaga() {
  yield takeLatest(BANK_SWAP_GET_REQUEST, getBankSwapSaga);
  yield takeLatest(BANK_SWAP_CALCULATE_REQUEST, calculateBankSwapSaga);
  yield takeLatest(CALCULATE_SWAP_WITH_QUOTE.value, calculateSwapWithQuoteSaga);
  yield takeLatest(CALCULATE_SWAP_WITHOUT_QUOTE.value, calculateSwapWithoutQuoteSaga);
}
